var _ellipse, _ellipse2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 188,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 140,
    cy: 94.27,
    rx: 140,
    ry: 93.583,
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 280,
    height: 188
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 94.27,
    rx: 140,
    ry: 93.583,
    fill: "#8DE995"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.297 89.604c-2.088 1.707-14.112 36.092-14.112 36.092l-42.926-1.934-1.77-30.325-9.744-1.934 6.958-15.19a16.308 16.308 0 0 1 14.176-9.509l19.615-.79v.007l8.695-.356 16.946-.683c.176-.007.349 0 .524-.001.669 1.406 7.296 11.387 8.297 12.636 0 0-.773 7.176-6.66 11.987z",
    fill: "#C6F8E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.97 52.56c2-2.608-1.143-.612-1.143-.612l-3.436-.396c-.563-.874-1.11.045-2.222.09-.286.011 1.122 3.626.865 3.711-.418.137-3.075-7.563-3.383-7.276a6.149 6.149 0 0 1-1.242-4.158c.217-3.523 2.839-3.27 2.839-3.27 1.416-2.834 8.243-5.75 13.409-1.65 5.166 4.098 2.119 9.335 2.119 9.335l-7.962.32",
    fill: "#352C47"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.167 120.049 45.128-1.817 33.214 37.917a15.863 15.863 0 0 1 4.097 11.225l-2.465 67.824-14.272.574-1.209-67.702-29.745-36.547-17.212.693-5.44 105.714-14.271.575 2.175-118.456z",
    fill: "#93EBC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m60.486 58.581-3.614-.792.316 7.876-8.694.356-.516-12.811a3.01 3.01 0 0 1-2.308-2.8 2.979 2.979 0 0 1 .98-2.333 2.93 2.93 0 0 1 1.095-.645 2.96 2.96 0 0 1 .815-.16 3.019 3.019 0 0 1 2.661 1.399l4.385-5.163s2.206 2.54.207 5.146l7.962-.32.289 7.153a3.023 3.023 0 0 1-3.578 3.094",
    fill: "#F5C5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.496 82.41c17.226-4.606 59.859-13.385 92.59-11.662 32.73 1.724 69.728 7.607 86.403 11.233",
    stroke: "#64D3A3",
    strokeWidth: 8.676
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.106,
    cy: 81.729,
    rx: 10.772,
    ry: 10.735,
    transform: "rotate(11.443 91.106 81.729)",
    fill: "#55C293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.823 81.058c-6.957 25.57 20.069 40.019 33.617 42.614l14.058-61.393c-13.549-5.35-42.491-.273-47.675 18.78z",
    fill: "#71EEB8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.594,
    cy: 92.526,
    rx: 11.31,
    ry: 31.46,
    transform: "rotate(11.245 128.594 92.526)",
    fill: "#62DAA6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.402,
    ry: 5.116,
    transform: "matrix(.9808 .19506 -.17391 .98476 131.589 81.342)",
    fill: "#55C293"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.402,
    ry: 5.116,
    transform: "matrix(.9808 .19506 -.17391 .98476 127.65 104.992)",
    fill: "#55C293"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m72.057 69.126 1.457 6.458L92.805 93.09a12.265 12.265 0 0 1 3.925 7.73c.47 4.365-2.817 8.218-7.162 8.393a7.5 7.5 0 0 1-6.733-3.659l-14.388-24.01-8.708-8.504 5.893-6.444 6.425 2.53M7.919 90.855l.028-.736 38.08-14.182 6.846-4.394 5.502 3.615 1.247 8.813-4.475.616-7.072.964-26.144 12.906-3.201 1.577c-4.97 2.449-11.05-2.714-10.811-9.179",
    fill: "#F5C5B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.246 101.286 245.558 83.12a12.194 12.194 0 0 0-10.984-5.997l-34.61 1.393a12.176 12.176 0 0 0-10.609 7.159l-8.827 19.523a6.72 6.72 0 0 0-.592 3.019l.024.599c.128 3.182 2.349 6.028 5.476 6.586a6.645 6.645 0 0 0 6.971-3.267l4.631-8.173 3.401 18.563 36.961-1.488 2.331-23.077 6.149 9.716-.308 27.217 8.872-.357 2.926-28.086a8.508 8.508 0 0 0-1.124-5.164z",
    fill: "#C6F8E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.438 122.525 182.52 225.009l10.307 2.784 23.256-91.947 6.687-.269 12.682 90.15 10.665-.43-8.717-104.26-36.962 1.488z",
    fill: "#93EBC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m245.572 134.893-2.666 2.922 3 5.081 8.159-.329.379-8.031-8.872.357zm-24.866-71.867c-.218-1.273-1.266-2.184-2.484-2.315a2.745 2.745 0 0 0-.773.013 2.785 2.785 0 0 0-1.411.696c-2.172-1.058-3.195-3.419-3.195-3.419l-9.115 6.461 1.146 6.602a2.817 2.817 0 0 0 3.869 2.124l3.142-1.433 1.072 6.238 8.196-.33-2.003-11.624a2.825 2.825 0 0 0 1.556-3.014z",
    fill: "#C98E7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.989 56.56c-1.766-1.913-4.505-2.86-7.069-2.431-1.359.227-2.811.8-4.049.198-1.128-.55-1.609-1.864-2.318-2.907-1.606-2.386-4.852-3.515-7.6-2.64-1.903.61-3.927 2.643-4.637 4.81a10.145 10.145 0 0 0-5.859-.739c-4.69.811-10.951 3.969-7.729 11.611l9.114-6.46s1.023 2.36 3.195 3.418a2.79 2.79 0 0 1 1.412-.696c.26-.046.522-.04.772-.013 1.219.13 2.267 1.042 2.485 2.314a2.825 2.825 0 0 1-1.556 3.014l.654 3.843s3.733-3.608 2.724-9.46c-.386-2.2-1.371-3.93-2.719-5.19 1.571-.285 3.094-.274 4.767.79 1.465.94 2.523 2.391 3.716 3.664a20.1 20.1 0 0 0 4.961 3.84c2.104 1.149 4.55 1.922 6.898 1.428 2.347-.495 4.465-2.565 4.38-4.964-.04-1.28-.683-2.485-1.542-3.43z",
    fill: "#2C2C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.672 100.196c9.54 1.552 35.303 1.091 62.035-13.171 33.414-17.828 55.734-43.775 66.168-81.482 10.433-37.707 11.102-46.408 19.53-58.011",
    stroke: "#65D6A5",
    strokeWidth: 8.676
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.654 97.664c.573 24.249-20.142 28.613-30.572 27.765l3.11-56.21c5.633-.996 26.89 4.197 27.462 28.445z",
    fill: "#62DAA6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.854,
    y: 103.14,
    width: 21.801,
    height: 6.64,
    rx: 3.32,
    transform: "rotate(6.04 133.854 103.14)",
    fill: "#55C293"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.711,
    y: 78.635,
    width: 21.801,
    height: 6.64,
    rx: 3.32,
    transform: "rotate(6.04 137.711 78.635)",
    fill: "#55C293"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.559,
    y: 64.267,
    width: 16.096,
    height: 62.589,
    rx: 3.155,
    transform: "rotate(7.209 155.559 64.267)",
    fill: "#71EEB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m190.38 102.87.374-8.146 8.065-.325 1.372 8.076-4.764 3.71-5.047-3.315z",
    fill: "#C98E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.872 69.19c0-.999.674-3.22 3.369-4.118M51.658 52.367c.98-.187 3.289.059 4.676 2.538",
    stroke: "#2C2C4E",
    strokeWidth: 1.577
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 280,
    y1: 0.687,
    x2: -6.747,
    y2: 11.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAF5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionError);
export default __webpack_public_path__ + "static/media/connection-error.e61d4d7f3aa7c5c97a52c8721345cf61.svg";
export { ForwardRef as ReactComponent };